import { computed } from '@ember/object';
export default function sameProperty(propertyOne, propertyTwo) {
  return computed(propertyOne, propertyTwo, function () {
    return this.get(propertyOne) === this.get(propertyTwo);
  });
}